export const TIMETABLE = '/timetable'
